import { Injectable } from '@angular/core';
import { BiometricAuth, BiometryError, BiometryErrorType, BiometryType } from '@aparajita/capacitor-biometric-auth';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

@Injectable({ providedIn: 'root' })
export class BiometricLoginService {
  async isBiometricAvailable(): Promise<boolean> {
    try {
      const res = await BiometricAuth.checkBiometry();
      return res.isAvailable;
    } catch {
      return false; // Retorna false se houver erro ao verificar biometria
    }
  }

  async authenticateWithBiometrics(): Promise<boolean> {
    try {

      BiometricAuth.setBiometryType(BiometryType.fingerprintAuthentication)

      await BiometricAuth.authenticate({
        reason: 'Acessar Conta',
        cancelTitle: 'Cancelar',
        allowDeviceCredential: true,
        iosFallbackTitle: 'Usar a senha',
        androidTitle: 'Acessar Conta',
        androidSubtitle: 'Verificação de identidade',
      });
      return true;
    } catch (error) {
      if (error instanceof BiometryError) {
        switch (error.code) {
          case BiometryErrorType.userCancel:
            throw new Error("Autenticação cancelada.")
          case BiometryErrorType.biometryNotAvailable:
            throw new Error('Biometria não está disponível neste dispositivo.');
          case BiometryErrorType.biometryNotEnrolled:
            throw new Error('Nenhuma biometria configurada no dispositivo.');
          default:
            throw new Error(`Erro na autenticação biométrica: ${error.message}`);
        }
      }
    }
  }

  async saveRefreshToken(refresh_token: string): Promise<void> {
    if (!refresh_token) {
      throw new Error('Refresh token inválido para armazenamento.');
    }
    try {
      await SecureStorage.set(
        'refresh_token',
        refresh_token
      );
    } catch (error) {
      throw new Error('Falha ao salvar credenciais: ' + error.message);
    }
  }

  /**
   * Diz se ja existe um refresh token no cofre, sem disparar prompt biometrico
   * (SecureStorage.get e silencioso). Usado pra sincronizar o cofre so quando
   * a biometria ja foi estabelecida, sem gravar credencial nova pra quem nunca
   * usou biometria.
   */
  async hasStoredRefreshToken(): Promise<boolean> {
    try {
      const res = await SecureStorage.get('refresh_token');
      return !!res?.toString();
    } catch {
      return false;
    }
  }

  async getRefreshToken(): Promise<string | null> {
    try {
      const res = await SecureStorage.get('refresh_token');
      const refresh_token = res?.toString()
      if (!refresh_token) {
        throw new Error('Token armazenado inválido');
      }
      return refresh_token;
    } catch (error) {
      console.error('Erro ao recuperar token:', error);
      return null;
    }
  }
}
